import React, { useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

import { avatarRules } from "../../../../../arc/forms/avatar.js";
import { Locale } from "../../../../assets/Locale.js";

const avatarAccept = avatarRules.types.join(",");

export const AvatarDropZone = (props)=>{
    const { dragOver, onBrowse } = props;
    const say = Locale.use();
    const inputRef = useRef(null);

    const openPicker = _=>{
        inputRef.current?.click();
    };

    const browse = event=>{
        onBrowse(event.target.files?.[0] || null);
        event.target.value = "";
    };

    return (
        <Box className={dragOver ? "AvatarForm-dropZone isDragOver" : "AvatarForm-dropZone"}>
            <input
                accept={avatarAccept}
                className="AvatarForm-fileInput"
                onChange={browse}
                ref={inputRef}
                type="file"
            />
            {dragOver ? (
                <Typography className="AvatarForm-dropTitle">{say("profileAvatarDropHere")}</Typography>
            ) : (
                <Button
                    className="BlimpMuiPanel-actionPrimary"
                    onClick={openPicker}
                    startIcon={<FileUploadOutlinedIcon />}
                    type="button"
                    variant="contained"
                >
                    {say("profileAvatarActionUpload")}
                </Button>
            )}
        </Box>
    );
};
